import { render } from "./EventVideoRoom.vue.js?vue&type=template&id=8a53e906!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EventVideoRoom.vue?vue&type=template&id=8a53e906"
import script from "./EventVideoRoom.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EventVideoRoom.vue?vue&type=script&lang=js"
export * from "./EventVideoRoom.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EventVideoRoom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/FanWeb/scripts/dynamic-components/standard-pages/event-page/EventVideoRoom.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8a53e906"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8a53e906', __exports__)) {
    api.reload('8a53e906', __exports__)
  }
  
  module.hot.accept("./EventVideoRoom.vue.js?vue&type=template&id=8a53e906!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EventVideoRoom.vue?vue&type=template&id=8a53e906", () => {
    api.rerender('8a53e906', render)
  })

}


export default __exports__